import axios from 'axios';
import _ from 'lodash';
import Config from 'config';
import grabStorage from 'grab-storage';

function makeRequest(request, accessToken) {
  if (process.env.NODE_ENV === 'development' && grabStorage.mock === 'true' && request.mock) {
    /* eslint-disable global-require */
    const mocks = require('../mocks').default;

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const requestUrl = `${request.method} ${request.url}`;
        if (request.mock.fail) {
          reject({
            status: request.mock.status,
            message: mocks[`${requestUrl}#fail`],
          });
        } else {
          resolve(mocks[requestUrl]);
        }
      }, request.mock.delay);
    });
  }

  const req = _.cloneDeep(request);
  req.url = Config.API_BASE_URL + request.url;
  req.headers = {
    'Content-Type': 'application/json',
  };

  if (accessToken) {
    req.headers.Authorization = accessToken;
  }

  return axios(req).then(response => response.data);
}

export const API_REQUEST = Symbol('API_REQUEST');
export const REQUEST = '_REQUEST';
export const SUCCESS = '_SUCCESS';
export const FAILURE = '_FAILURE';

export default store => next => (action) => {
  if (!action.meta || !action.meta[API_REQUEST]) {
    // Non-api request action
    return next(action);
  }

  // type     is the base action type that will trigger
  // payload  is the request body to be processed
  const { type, payload, meta } = action;

  // Swap the action content and structured api results
  function constructActionWith(data) {
    const finalAction = { ...action, ...data };
    delete finalAction[API_REQUEST];
    return finalAction;
  }

  // Propagate the start of the request.
  next(constructActionWith({
    type: type + REQUEST,
    payload,
    meta: {
      ...meta,
      requestStatus: REQUEST,
    },
  }));

  // Get the access token from store.
  let accessToken = '';
  if (_.get(store.getState(), 'app.user.accessToken')) {
    accessToken = store.getState().app.user.accessToken;
  }

  // Propagate the response of the request.
  return makeRequest(payload, accessToken)
    .then(response => next(constructActionWith({
      type: type + SUCCESS,
      payload: response,
      meta: {
        ...meta,
        requestStatus: SUCCESS,
        request: payload,
      },
    })),
    error => next(constructActionWith({
      type: type + FAILURE,
      payload: error,
      meta: {
        ...meta,
        requestStatus: FAILURE,
        request: payload,
      },
    }))
    );
};



/** WEBPACK FOOTER **
 ** ./src/js/middlewares/api-middleware.js
 **/